import versionInfo from "~/generated/version.json"

export const ORBIT_COLOR = "#e83c60"

export const GITHUB_LOGO = "https://assets.orbit.buape.com/github.png"

export const VERSION_INFO = versionInfo
export const VERSION =
	versionInfo.gitDescribe ?? versionInfo.shortGitSha ?? "dev"
